import { render, staticRenderFns } from "./science-achieve.vue?vue&type=template&id=2f99c17c&scoped=true&"
import script from "./science-achieve.vue?vue&type=script&lang=js&"
export * from "./science-achieve.vue?vue&type=script&lang=js&"
import style0 from "./science-achieve.vue?vue&type=style&index=0&id=2f99c17c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f99c17c",
  null
  
)

export default component.exports